import React, { useState } from "react";
import styled, { useTheme } from "styled-components";
import { Button, Grid, Link, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";
const Wrapper = styled.div`
  position: fixed;
  z-index: 10;
  width: 100%;
  bottom: 0;
  left: 0;
  background-color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.background.dark;
}};
  padding: 1.5em;
  display: flex;
  justify-content: center;
`;
const Content = styled.div`
  max-width: 1440px;
  width: 100%;
`;
const CookieConsent = () => {
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const name = "cookie-consent";
  const value = 1;
  const [hidden, setHidden] = useState(false);
  const [cookies, setCookie] = useCookies([name]);
  const declineClick = () => {
    setHidden(true);
  };
  const consentClick = () => {
    setCookie(name, value);
  };
  if (cookies[name] === value || hidden) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    align: "center",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 3.7
  }, t("CookieConsent.text"), ".", " ", /*#__PURE__*/React.createElement(Link, {
    href: t("CookieConsent.privacyPolicyUrl"),
    color: colors.primary.main,
    underline: true
  }, t("CookieConsent.privacyPolicy"))), /*#__PURE__*/React.createElement(Grid.Cell, {
    justify: "end",
    align: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primaryTransparent",
    onClick: declineClick,
    s: {
      px: 4,
      py: 2
    },
    rounded: true,
    display: "inline-block"
  }, t("common.actions.decline")), /*#__PURE__*/React.createElement(Button, {
    onClick: consentClick,
    s: {
      px: 4,
      py: 2,
      ml: 2
    },
    rounded: true,
    display: "inline-block"
  }, t("CookieConsent.consent"))))));
};
export default CookieConsent;